<template>
  <div class="PreviewImg">
    <van-image-preview v-model="PreviewSetting.isShow" lazy-load :images="PreviewSetting.img" :start-position="PreviewSetting.indexes" @change="onChange">
      <!-- <template v-slot:index>{{ index }}</template> -->
    </van-image-preview>
  </div>
</template>

<script>
/*
* 图片预览组件
*/ 
export default {
  props: {
    PreviewSetting: {
      type: Object,
      default: {
        img: [],
        isShow: false,
        indexes: 0
      }
    },
  },
  data() {
    return {
      index: 0,
    }
  },
  methods: {
    onChange(index) {
      this.index = index
    }
  }
}
</script>

<style lang="less">
.PreviewImg {
  .van-image-preview__index{
    top: 40px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/PreviewImg.vue